import React, { useState, useEffect } from "react";
import { Card, Button, Form } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector, shallowEqual } from "react-redux";
import * as apiFile from "../../api/file";
import * as apiUtenti from "../../api/users";
import {
  roles,
  icons,
  categorieFile,
  nomiCategorieFile,
  nomiCategorieFilePlural,
  fileVisibilityGroups,
  isAgente,
  variantiManuale,
  nomiVariantiManuale,
} from "../../config/config";
import Swal from "sweetalert2";

const validationSchema = yup.object({
  name: yup
    .string("Inserire un nome valido")
    .required("Inserire un nome valido")
    .min(3, "Minimo tre caratteri")
    .max(100, "Massimo cinquanta caratteri"),
  idAgente: yup
    .number("Inserire un utente valido")
    // .moreThan(-3, "Selezionare un utente o un gruppo")
    //.required("Seleziona un utente"),
});

const actionsMessages = {
  new: "Carica",
  edit: "Modifica",
  reset: "Reset",
};

const formFields = {
  name: {
    label: "Nome",
    placeholder: "Nome file...",
  },
  idAgente: {
    label: "Visibile a ",
  },
  file: {
    label: "File",
  },
  prefix: {
    label: "Prefisso",
    placeholder: "RENDICONTO / UNICO / IMS ...",
  },
  variant: {
    label: "Tipo",
  }
};

const EditNewFileToolbar = ({
  submitCallback,
  resetCallback,
  closeCallback,
  loading,
  existingFile,
  type,
  ...props
}) => {
  return (
    <div {...props}>
      <Button
        disabled={loading}
        onClick={submitCallback}
        className="my-1 ml-2 d-inline-flex align-items-center"
      >
        <span className="svg-icon svg-icon-md svg-icon-light-primary">
          <SVG src={toAbsoluteUrl(icons.ok)} />
        </span>
        {existingFile ? actionsMessages.edit : actionsMessages.new}
      </Button>
      <Button
        disabled={loading}
        onClick={resetCallback}
        variant="secondary"
        className="my-1 ml-2 d-inline-flex align-items-center"
      >
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.reset)} />
        </span>
        {actionsMessages.reset}
      </Button>
      <Button
        onClick={closeCallback}
        variant="secondary"
        className="my-1 ml-2 d-inline-flex align-items-center"
      >
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.go_back)} />
        </span>
        {nomiCategorieFilePlural[type]}
      </Button>
    </div>
  );
};

export const EditNewFile = (props) => {
  const [loading, setLoading] = useState(false);

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);
  
  const isContabile = role === roles.contabile;
  const isDipendente = role === roles.dipendente;
  const isAdmin = role === roles.admin || role === roles.gestore || role === roles.developer;
  const isGraficoHandlingManuale = (role === roles.grafico || role === roles.magazziniere) && props.type === categorieFile.manuali;

  var initialState = {
    name: "",
    idAgente: -100,
    prefix: "",
    variant: "",
  };
  const existingFile = props.file !== false;
  if (existingFile) {
    Object.assign(initialState, props.file);
    initialState.variant = props.file.variant || "";
  }
  const [name, setName] = useState(initialState.name);
  const [idAgente, setIdAgente] = useState(initialState.idAgente);
  const [prefix, setPrefix] = useState(initialState.prefix);
  const [variant, setVariant] = useState(initialState.variant);
  const [newFiles, setNewFiles] = useState([]);

  const isManuali = props.type === categorieFile.manuali;

  const handleReset = () => {
    setName(initialState.name);
    setIdAgente(initialState.idAgente);
    setPrefix(initialState.prefix);
    setVariant(initialState.variant);
    setNewFiles([]);
    formik.handleReset();
  };

  const [agenti, setAgenti] = useState([]);
  // const rolesList = props.type === categorieFile.documenti 
  //   ? [roles.admin, roles.developer, roles.magazziniere, roles.dipendente, roles.grafico]
  //   : [roles.admin, roles.developer, roles.agenteCompleto, roles.agenteValderma, roles.agenteRoydermal, roles.agenteRoypet];
  const customFileVisibilityGroups = props.type === categorieFile.documenti 
    ? [fileVisibilityGroups[0]]
    : fileVisibilityGroups
  useEffect(() => {
    if (isAdmin || isContabile || isDipendente) {
      apiUtenti.getAll(props.token)
      .then((data) => {
        var parsed = data
          //.filter((u) => rolesList.indexOf(parseInt(u.role)) > 0)
          .map((u) => ({ value: u.id, label: u.fullname, isAgente: isAgente(parseInt(u.role)), lastname: u.lastname, firstname: u.firstname }));

        parsed = parsed.sort((a, b) => (a.lastname.toLowerCase() > b.lastname.toLowerCase()) ? 1 : -1);
        
        setAgenti(parsed);
      });
    }
    /*eslint-disable-next-line*/
  }, []);

  const buildFormData = (file, values, prefix,isBulkUpload) => {
    const fd = new FormData();
    fd.append("name", values.name); // considera renderlo unico per ogni file
    if (isAdmin || isContabile || isGraficoHandlingManuale || isDipendente) {
      fd.append("idAgente", parseInt(values.idAgente));
    }
    fd.append("prefix", prefix);
    fd.append("type", props.type);
    if (isManuali) {
      fd.append("variant", values.variant);
    }
    fd.append("accessToken", user.authToken);
    fd.append("file", file); // chiave corretta
    if (isBulkUpload) {
      fd.append("isBulkUpload", true);
    }
    
    return fd;
  };

  const formik = useFormik({
    initialValues: {
      name: name,
      idAgente: idAgente,
      files: newFiles,
      prefix: prefix,
      variant: variant,
    },
    enableReinitialize: true,
    //Se seleziono più di 1 file il campo name NON è obbligatorio
    validationSchema: 
      (() => {
        const variantField = isManuali
          ? yup
              .string("Selezionare un tipo di manuale")
              .oneOf(["", ...variantiManuale], "Selezionare un tipo di manuale")
              .required("Selezionare un tipo di manuale")
          : yup.string().notRequired();
        const variantFieldOptional = isManuali
          ? yup
              .string("Selezionare un tipo di manuale")
              .oneOf(["", ...variantiManuale], "Selezionare un tipo di manuale")
          : yup.string().notRequired();
        if (newFiles.length > 1) {
          return yup.object().shape({
            name: yup.string().notRequired(),
            idAgente: yup.number().notRequired(),
            prefix: yup.string().notRequired(),
            variant: variantField,
          });
        }
        return yup.object().shape({
          name: validationSchema.fields.name,
          idAgente: validationSchema.fields.idAgente,
          prefix: yup.string().notRequired(),
          variant: existingFile ? variantFieldOptional : variantField,
        });
      })(),
    
    onSubmit: (values, { setStatus, setSubmitting }) => {
      console.log('before: %o', values);
      values.idAgente = idAgente;
      values.name = name;
      values.variant = variant;
      console.log('after: %o', values);
      if (
        existingFile &&
        values.name === initialState.name &&
        values.idAgente === initialState.idAgente &&
        values.variant === initialState.variant
      ) {
        Swal.fire({
          icon: "error",
          title: "Nessuna modifica fatta",
          confirmButtonColor: "#3699ff",
          confirmButtonText: "Chiudi",
        });
        return;
      }
      if (!existingFile && newFiles.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Nessun file selezionato",
          confirmButtonColor: "#3699ff",
          confirmButtonText: "Chiudi",
        });
        return;
      }
      const agenteDropdownItem = (values.idAgente > 0)
        ? agenti.find((a) => a.value === parseInt(values.idAgente))
        : fileVisibilityGroups.find((g) => g.value === parseInt(values.idAgente));
      const fileUploadedForStr = ((isAdmin || isContabile || isDipendente || isGraficoHandlingManuale) && (typeof agenteDropdownItem !== "undefined")) 
        ? " per " + agenteDropdownItem.label 
        : "";
      Swal.fire({
        title: "Richiesta",
        html: `<p>Sei sicuro di voler ${
          existingFile ? "modificare il file" : "caricare il file"
        } "${name}"${fileUploadedForStr}?</p>`,
        confirmButtonColor: "#3699ff",
        cancelButtonColor: "#f64e60",
        showDenyButton: true,
        confirmButtonText: "Conferma",
        denyButtonText: `Annulla`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const isBulkUpload = newFiles.length > 1;
          const requestPromise = existingFile
            ? apiFile.edit(
                user.authToken,
                props.file.id,
                values.name,
                (isAdmin || isContabile || isDipendente || isGraficoHandlingManuale) ? parseInt(values.idAgente) : undefined,
                props.type,
                isManuali ? values.variant : undefined
              )
            : Promise.all(newFiles.map((f) => apiFile.add(buildFormData(f, values, prefix, isBulkUpload))));

          requestPromise
            .then(() => {
              setLoading(false);
              props.triggerServerUpdate();
              props.hideEditPage();
              Swal.fire({
                icon: "success",
                title: existingFile ? "File modificato con successo" : "File caricato con successo",
                confirmButtonColor: "#3699ff",
                confirmButtonText: "Chiudi",
              });
            })
            .catch((err) => {
              setSubmitting(false);
              setLoading(false);
              Swal.fire({
                icon: "error",
                title: err.plainMessage,
                confirmButtonColor: "#3699ff",
                confirmButtonText: "Chiudi",
              });
            });
        } else if (result.isDenied) {
          // no-op
        }
      });
    },
  });
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  return (
    <Card className="card-custom gutter-b">
      <Card.Header className="border-0 py-5 row">
        <Card.Title className="float-left col-auto">
          <h3 className="font-weight-bolder text-dark">
            {existingFile ? actionsMessages.edit : actionsMessages.new}{" "}
            {nomiCategorieFile[props.type]}
          </h3>
        </Card.Title>
        <EditNewFileToolbar
          submitCallback={formik.handleSubmit}
          resetCallback={handleReset}
          closeCallback={props.hideEditPage}
          loading={loading}
          existingFile={existingFile}
          type={props.type}
          className="float-right col-auto"
        />
      </Card.Header>
      <Card.Body className="pt-0">
        <Form className="row" onSubmit={formik.handleSubmit}>
          {formik.status && (
            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          )}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields.name.label}</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder={formFields.name.placeholder}
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={getInputClasses("name")}
              /* {...formik.getFieldProps("name")} */
            />
            {formik.touched.name && formik.errors.name ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.name}</div>
              </div>
            ) : null}
          </Form.Group>
          {(isAdmin || isContabile || isDipendente || isGraficoHandlingManuale) ? (<Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">
              {formFields.idAgente.label}
            </Form.Label>
            <select
            
              value={idAgente}
              onChange={(e) =>
                e !== null ? setIdAgente(e.target.value) : null
              }
              name="idAgente"
              className={`form-control ${getInputClasses("idAgente")}`}
              /* {...formik.getFieldProps("idAgente")} */
            >
              {customFileVisibilityGroups.map((group) => (
                <option key={group.value} value={group.value}>{group.label}</option>
              ))}
              {(props.type === categorieFile.documenti ? agenti : agenti.filter((u) => u.isAgente)).map((agente) => (
                <option key={agente.value} value={agente.value}>{agente.label}</option>
              ))}
            </select>
            {formik.touched.idAgente && formik.errors.idAgente ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.idAgente}</div>
              </div>
            ) : null}
          </Form.Group>) : <></>}
          {isManuali ? (
            <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
              <Form.Label className="col-12">
                {formFields.variant.label}
              </Form.Label>
              <select
                value={variant}
                onChange={(e) => setVariant(e.target.value)}
                name="variant"
                className={`form-control ${getInputClasses("variant")}`}
              >
                <option value="">Seleziona tipo...</option>
                {variantiManuale.map((v) => (
                  <option key={v} value={v}>{nomiVariantiManuale[v]}</option>
                ))}
              </select>
              {formik.touched.variant && formik.errors.variant ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.variant}</div>
                </div>
              ) : null}
            </Form.Group>
          ) : null}
          {existingFile ? null : <>
          
            <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
              <Form.Label className="col-12">
                {formFields.prefix.label}
              </Form.Label>
                <Form.Control
                  type="text"
                  name="prefix"
                  id="prefixField"
                  onChange={(e) => setPrefix(e.target.value)}
                />
            </Form.Group>
            <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
              <Form.Label className="col-12">
                {formFields.file.label}
              </Form.Label>
              <div className="custom-file">
                <Form.File
                  type="file"
                  className="custom-file-input"
                  name="file"
                  id="fileUploadField"
                  multiple
                  style={{ visibility: "hidden" }}
                  onChange={(e) => setNewFiles(Array.from(e.target.files || []))}
                />
                <label
                  className={`col-12 custom-file-label ${
                    newFiles.length > 0 ? null : "text-muted"
                  }`}
                  htmlFor="fileUploadField"
                >
                  {newFiles.length > 0 ? `${newFiles.length} file${newFiles.length > 1 ? "s" : ""} selezionati` : "Seleziona file"}
                </label>
              </div>
              <div className="fv-plugins-message-container">
                <div className="fv-help-block text-muted">
                  {" E' possibile selezionare 1 o più files "}
                  {/* {props.type === categorieFile.documenti ? 
                    "I file devono essere caricati in formato PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, JPEG, PNG, GIF."
                    : "I file devono essere caricati in formato JPG, JPEG, PNG, GIF."
                  } */}
                </div>
              </div>
            </Form.Group>
            </>
          }
        </Form>
      </Card.Body>
    </Card>
  );
};
